import { Locale, localeMessagesMap, StringKey } from '../lang/index';
import { localeStorage } from '../storage/local/index';

const locale = localeStorage.get() || Locale.EN;

export const getTranslation = (key: StringKey, params?: Record<string, number | string>) => {
  // Only `en.json` is guaranteed to carry every key; without this fallback a key missing from the
  // active locale returned `undefined` and threw as soon as it had placeholders to fill.
  const translation = localeMessagesMap[locale][key] ?? localeMessagesMap[Locale.EN][key];
  if (!params) return translation;

  return translation.replace(/{(\w+)}/g, (_, placeholder) => {
    const value = params[placeholder];
    return value !== undefined ? String(value) : `{${placeholder}}`;
  });
};
